import { Step } from "react-joyride";

export function buildTourSteps(...groups: Step[][]): Step[] {
  const combined = groups.flat();
  const totalSize = combined.length;

  return combined.map((step, idx) => ({
    ...step,
    data: {
      ...step.data,
      stepNumber: idx + 1,
      totalSteps: totalSize,
    },
  }));
}